/* Amorati — Remembered Ring Size */
(function () {
  var STORAGE_KEY = 'amorati_ring_size';

  function getStoredSize() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setStoredSize(value) {
    if (!value) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* private browsing / storage disabled — fail silently */
    }
  }

  function dispatch(el, type) {
    var evt;
    try {
      evt = new Event(type, { bubbles: true });
    } catch (e) {
      evt = document.createEvent('Event');
      evt.initEvent(type, true, true);
    }
    el.dispatchEvent(evt);
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function nativeSizeInputs(root) {
    var scope = root || document;
    var standard = toArray(scope.querySelectorAll('[name="options[Ring Size]"]'));
    if (standard.length) return standard;
    return toArray(scope.querySelectorAll('[name^="Ring Size-"]'));
  }

  function fallbackSizeSelects(root) {
    return toArray((root || document).querySelectorAll('select[data-amorati-size]'));
  }

  function currentValue(inputs) {
    if (!inputs.length) return null;
    if (inputs[0].tagName === 'SELECT') return inputs[0].value || null;
    var checked = inputs.filter(function (i) {
      return i.checked;
    })[0];
    return checked ? checked.value : null;
  }

  function applyValue(inputs, value) {
    if (!inputs.length || !value) return false;
    if (inputs[0].tagName === 'SELECT') {
      var hasOption = toArray(inputs[0].options).some(function (o) {
        return o.value === value;
      });
      if (!hasOption) return false;
      inputs[0].value = value;
      dispatch(inputs[0], 'change');
      return true;
    }
    var match = inputs.filter(function (i) {
      return i.value === value;
    })[0];
    if (!match) return false;
    match.checked = true;
    dispatch(match, 'change');
    dispatch(match, 'click');
    return true;
  }

  function showRememberedNote(inputs) {
    if (!inputs.length) return;
    var field = inputs[0].closest('.variant-picker__field, .amorati-ring-size');
    if (!field || field.querySelector('.amorati-remembered-note')) return;
    var note = document.createElement('span');
    note.className = 'amorati-remembered-note text-sm';
    note.innerHTML =
      ' We remembered your size &mdash; <button type="button" class="btn--link amorati-remembered-note__clear">not this time?</button>';
    field.appendChild(note);
    note.querySelector('.amorati-remembered-note__clear').addEventListener('click', function () {
      note.remove();
    });
  }

  function initField() {
    var stored = getStoredSize();
    if (!stored) return;

    var native = nativeSizeInputs(document);
    if (native.length) {
      if (currentValue(native)) return; /* already has a selection — don't override */
      if (applyValue(native, stored)) showRememberedNote(native);
      return;
    }

    fallbackSizeSelects(document).forEach(function (sel) {
      if (sel.value) return; /* already has a selection */
      if (applyValue([sel], stored)) showRememberedNote([sel]);
    });
  }

  function nativeSizeInputsForForm(form) {

    return nativeSizeInputs(document).filter(function (input) {
      return input.form === form;
    });
  }

  function bindRemember(root) {
    var forms = (root || document).querySelectorAll('form[data-type="add-to-cart-form"], form.sticky-atc-form');
    toArray(forms).forEach(function (form) {
      if (form.__amoratiSizeMemoryBound) return;
      form.__amoratiSizeMemoryBound = true;
      form.addEventListener('submit', function () {
        var native = currentValue(nativeSizeInputsForForm(form));
        if (native) {
          setStoredSize(native);
          return;
        }
        var id = form.getAttribute('id');
        var fallback = id ? document.querySelector('select[data-amorati-size][form="' + id + '"]') : null;
        if (fallback && fallback.value) setStoredSize(fallback.value);
      });
    });
  }

  function bestSizeVariantId(list, size) {
    if (!list || !list.length || !size) return null;
    var match = list.filter(function (v) {
      return v.available && v.size === size;
    })[0];
    return match ? match.id : null;
  }

  function resolveForButton(btn) {
    var result = { variantId: btn.getAttribute('data-variant-id') || null, properties: null };
    var stored = getStoredSize();
    if (!stored) return result;

    var variantsRaw = btn.getAttribute('data-ring-variants');
    if (variantsRaw) {
      var list = null;
      try {
        list = JSON.parse(variantsRaw);
      } catch (e) {
        list = null;
      }
      var variantId = bestSizeVariantId(list, stored);
      if (variantId) result.variantId = variantId;
      return result;
    }

    if (btn.getAttribute('data-ring-size-property') === 'true') {
      var props = {};
      var existingRaw = btn.getAttribute('data-line-item-properties');
      if (existingRaw) {
        try {
          props = JSON.parse(existingRaw) || {};
        } catch (e) {
          props = {};
        }
      }
      props['Ring Size'] = stored;
      result.properties = props;
    }

    return result;
  }

  function init() {
    initField();
    bindRemember(document);
    /* re-run once the sticky add-to-cart bar injects its cloned size field */
    document.addEventListener('amorati:sticky-size-ready', function () {
      initField();
      bindRemember(document);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  window.AmoratiRingSize = window.AmoratiRingSize || {};
  window.AmoratiRingSize.resolveForButton = resolveForButton;
  window.AmoratiRingSize.getStoredSize = getStoredSize;
  window.AmoratiRingSize.setStoredSize = setStoredSize;
})();
